import { Link } from "react-router-dom";
import { LEISTUNGEN, SERVICE_LINKS } from "@/data/content";

export default function Leistungen() {
  return (
    <div data-testid="page-leistungen">
      <section className="py-16 md:py-20 border-b border-[#24211D]/10">
        <div className="max-w-6xl mx-auto px-6">
          <span className="text-xs uppercase tracking-[0.2em] text-[#B08D57] block mb-2 font-sans">Atelier Portfolio</span>
          <h1 className="text-[clamp(36px,4.5vw,64px)] leading-tight mb-6">Leistungen & Richtpreise</h1>
          <p className="text-base text-[#24211D]/80 max-w-2xl leading-relaxed">
            Von Balayage bis Kinderhaarschnitt: Alle Leistungen mit ehrlicher Beratung, kurzen Wartezeiten und oft kurzfristig freien Terminen. Die genauen Preise erhalten Sie nach der kostenlosen Beratung.
          </p>
        </div>
      </section>

      {LEISTUNGEN.map((cat) => (
        <section key={cat.category} className="py-16 border-b border-[#24211D]/10" data-testid={`category-${cat.category.toLowerCase().replace(/[^a-z]/g, "-")}`}>
          <div className="max-w-6xl mx-auto px-6">
            <div className="mb-10">
              <span className="text-xs uppercase tracking-[0.2em] text-[#B08D57] block mb-2 font-sans">{cat.note}</span>
              <h2 className="text-3xl md:text-4xl">{cat.category}</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {cat.items.map((item) => (
                <div key={item.name} className="border border-[#24211D]/15 bg-[#FFFFFF] p-8 flex flex-col justify-between" data-testid={`leistung-${item.name.toLowerCase().replace(/[^a-z]/g, "-")}`}>
                  <div>
                    <h3 className="text-2xl mb-3">{item.name}</h3>
                    <p className="text-xs text-[#24211D]/75 leading-relaxed mb-4 font-sans">{item.desc}</p>
                    <p className="text-[11px] text-[#B08D57] uppercase tracking-[0.14em] font-sans mb-2">Dauer: {item.duration}</p>
                    {SERVICE_LINKS[item.name] && (
                      <Link to={SERVICE_LINKS[item.name]} data-testid={`leistung-more-${item.name.toLowerCase().replace(/[^a-z]/g, "-")}`} className="text-[11px] uppercase tracking-[0.14em] font-sans text-[#24211D]/60 hover:text-[#B08D57] underline underline-offset-4 mb-4 inline-block transition-colors duration-200">
                        Mehr erfahren →
                      </Link>
                    )}
                  </div>
                  <div className="pt-6 border-t border-[#24211D]/10 flex items-center justify-between">
                    <span className="text-sm font-sans font-bold">{item.price}{item.price.startsWith("ab") ? " *" : ""}</span>
                    <Link
                      to={`/kontakt?service=${encodeURIComponent(item.name)}#termin`}
                      data-testid={`leistung-book-${item.name.toLowerCase().replace(/[^a-z]/g, "-")}`}
                      className="text-xs uppercase tracking-widest text-[#B08D57] hover:text-[#24211D] font-sans transition-colors duration-200"
                    >
                      Termin buchen →
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}

      <section className="bg-[#F4EFE6] py-14">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="text-sm text-[#24211D]/80 leading-relaxed mb-2" data-testid="price-note">
            * Alle Preise sind Richtpreise („ab"). Der verbindliche Endpreis richtet sich nach Haarlänge, -dichte und Aufwand – Sie erfahren ihn vorab in der kostenlosen Beratung.
          </p>
          <p className="text-xs text-[#24211D]/60 font-sans mb-6">Genaue Preise nach kostenloser Beratung. <a href="/preisliste/" target="_blank" rel="noopener noreferrer" data-testid="preisliste-link" className="underline underline-offset-4 hover:text-[#B08D57] transition-colors duration-200">Preisliste zum Ausdrucken</a></p>
          <Link to="/kontakt#termin" data-testid="leistungen-cta-btn" className="bg-[#B08D57] hover:bg-[#967442] text-[#FBF8F3] px-10 py-4 text-xs uppercase tracking-[0.2em] font-sans transition-colors duration-300 inline-block">
            Termin buchen
          </Link>
        </div>
      </section>
    </div>
  );
}
